<h4 class="category-subtitle">Categories:</h4>
@if (selectedCategory && selectedActivities && activityCategories) {
  <div
    class="category-icons-container"
    >
    @for (category of activityCategories; track category) {
      <div>
        <button
          class="category-select-btn"
          [class.answered]="hasEntries(category)"
          [class.selected]="selectedCategory.id === category.id"
          (click)="selectCategory(category)"
          >
          <app-icon [name]="category.icon || 'wifi'" color="black"></app-icon>
        </button>
      </div>
    }
  </div>
}
@if (selectedActivities && selectedCategory) {
  <div>
    <p class="category-title">
      How many <strong>hours</strong> did you engage in
      <b>{{ selectedCategory.text.text_en || "" }}</b> today?
    </p>
    @for (activity of selectedActivities; track activity) {
      <div class="category-item">
        <b class="category-item-name">{{ activity.text.text_en }}</b>
        <p class="category-item-description">
          e.g. {{ activity.description.text_en }}
        </p>
        <div class="increment-decrement-controls">
          <button
            (click)="decrementDuration(activity.id)"
            class="increment-decrement-button"
            >
            -
          </button>
          <input
            type="text"
            matInput
            [value]="getDurationForActivity(activity.id)"
            disabled
            class="amount-indicator"
            />
          <button
            (click)="incrementDuration(activity.id)"
            class="increment-decrement-button"
            >
            +
          </button>
        </div>
      </div>
    }
  </div>
}
<div class="continue-button-container">
  <button class="btn" (click)="onContinue()">
    @if (
      selectedCategory && getNextCategoryIcon(selectedCategory) == 'home'
      ) {
      <span
        >Return to dashboard</span
        >
      }
      @if (
        selectedCategory && getNextCategoryIcon(selectedCategory) != 'home'
        ) {
        <span
          >Continue</span
          >
        }
        @if (selectedCategory) {
          <app-icon
            [name]="getNextCategoryIcon(selectedCategory)"
            size="24px"
            color="#fff"
          ></app-icon>
        }
      </button>
    </div>
